import React, { Component } from 'react'
import { Portal } from 'react-portal'
import { CookieBanner } from '@sketch/modules-common'
// renderprops.cjs is required to support Jest: https://github.com/react-spring/react-spring/issues/575
import { Transition } from 'react-spring/renderprops.cjs'
import { Box } from '@sketch/components'

const DISPLAY_DURATION = 30000

const getCookieConsent = () => {
  try {
    return (
      JSON.parse(window.localStorage.getItem('cookieConsent')) || {
        seen: false,
      }
    )
  } catch (e) {
    return {
      seen: false,
    }
  }
}

const updateCookieConsent = seen => {
  window.localStorage.setItem('cookieConsent', JSON.stringify({ seen }))
}

class CookieConsent extends Component {
  constructor(props) {
    super(props)
    this.state = { shouldAppear: !getCookieConsent().seen }
    this.timeoutRef = null
  }

  close = () => {
    this.setState({
      shouldAppear: false,
    })
    if (this.timeoutRef) window.clearTimeout(this.timeoutRef)
  }

  componentDidMount() {
    if (!this.state.shouldAppear) {
      return
    }

    updateCookieConsent(true)

    this.timeoutRef = window.setTimeout(this.close, DISPLAY_DURATION)
  }

  renderBanner = ({ opacity }) => {
    return (
      <Portal>
        <Box
          width={1}
          display="flex"
          justifyContent="center"
          px="1rem"
          mx="auto"
          style={{
            zIndex: 999,
            position: 'fixed',
            bottom: '2rem',
            opacity,
          }}
        >
          <CookieBanner onClickClose={this.close} />
        </Box>
      </Portal>
    )
  }

  render() {
    return (
      <Transition
        items={this.state.shouldAppear}
        from={{ opacity: 1 }}
        enter={{ opacity: 1 }}
        leave={{ opacity: 0 }}
      >
        {shouldAppear => props => shouldAppear && this.renderBanner(props)}
      </Transition>
    )
  }
}

export default CookieConsent
